// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"2381066c","158":"7a29bd83","372":"ff2d3575","376":"a347d2f9","488":"7fee30bf","522":"643f1e1c","558":"82f206b4","559":"190c0304","728":"f625e8ad","898":"4fc17cc1","919":"993c7c59","921":"38357763","987":"d80683a3"}[chunkId] + ".chunk.js";
};